import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';

// AUTOGENERATED -- DO NOT EDIT
var _ErxV1_instances, _ErxV1_baseUrlThunk;
class ErxV1 extends SDKResource {
    constructor(config) {
        super(config);
        _ErxV1_instances.add(this);
    }
    /**
     * Retrieve patient properties from FHIR service and sync them with eRx service
     */
    syncPatient(params, request) {
        return this.request('/erx/sync-patient/{patientId}', 'post', __classPrivateFieldGet(this, _ErxV1_instances, "m", _ErxV1_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Search for allergies
     */
    allergySearch(params, request) {
        return this.request('/erx/allergy/search', 'get', __classPrivateFieldGet(this, _ErxV1_instances, "m", _ErxV1_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Cancel photon order
     */
    cancelOrder(params, request) {
        return this.request('/erx/cancel-order', 'post', __classPrivateFieldGet(this, _ErxV1_instances, "m", _ErxV1_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Cancel photon prescription
     */
    cancelPrescription(params, request) {
        return this.request('/erx/cancel-prescription', 'post', __classPrivateFieldGet(this, _ErxV1_instances, "m", _ErxV1_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Search for medications. Provide at least one of code or name filters
     */
    medicationSearch(params, request) {
        return this.request('/erx/medication/search', 'get', __classPrivateFieldGet(this, _ErxV1_instances, "m", _ErxV1_baseUrlThunk).bind(this))(params, request);
    }
}
_ErxV1_instances = new WeakSet(), _ErxV1_baseUrlThunk = function _ErxV1_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : 'https://project-api.zapehr.com/v1';
};

export { ErxV1 };
//# sourceMappingURL=erxV1.js.map
